import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import Header from '../Layout/Header'
import HomeSlider from './HomeSlider'
import About from './About'
import Pramotion from './Pramotion'
import Services from './Services'
import Portfoliyo from './Portfoliyo'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import HeroAbout from './HeroAbout'
import HouseOffer from './HouseOffer'
import Aboutpro from './Aboutpro'
import PropertySection from './PropertySection'
import ProjectSection from './ProjectSection'
import ListProperty from './ListProperty'
import Team from './Team'
import Counter from './Counter'
import Testtomonial from './Testtomonial'
import NewsSection from './NewsSection'
import ContactSection from './ContactSection'
import Footer from '../Layout/Footer'
import NotificationBar from './NotificationBar'
import { useDispatch, useSelector } from 'react-redux'
import { allapiAction } from '../../Redux/common/action'
import PropertySlider2 from './PropertySlider2'
import FooterNew from '../Layout/FooterNew'
import LeadersSection from './LeadersSection'



function HomeComponents() {
        const get_home_all_pro = useSelector((state) =>
    state?.allapi?.get_home_all_pro ? state?.allapi?.get_home_all_pro : {}
  );
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(allapiAction.gethomePro({}));
    dispatch(allapiAction.getsliderList({ page: "home" }));
    // dispatch(allapiAction.getsliderList({ page: "home" }));
    // dispatch(allapiAction.getMarqueesList2({ page: "home" }));
  }, []);
  return (
    <div>
  


  <Header/>


{/* 
     <HomeSlider  /> */}
     {/* <PropertySlider2 /> */}
      {/* <NotificationBar/>  */}
  
     <HeroAbout />
     <HouseOffer/>
     <Aboutpro/>
           <LeadersSection />
     <PropertySection/>
     {/* <ProjectSection/> */}
     <ListProperty/>
 
     {/* <LeadersSection/> */}
     <Team/>
     {/* <Counter/> */}
     <Testtomonial/>
     <NewsSection/>
     <ContactSection/>
     <Footer/>
     <FooterNew />


{/* 
     <About/> */}

{/* <Pramotion/>
<Services/>
<Portfoliyo/> */}
    </div>
    
  )
}

export default HomeComponents